/**
 * MaxRyde Hero — subtle mouse parallax.
 * No dependencies. Respects prefers-reduced-motion and skips
 * entirely on touch/coarse-pointer devices.
 */
(function () {
  'use strict';

  var MAX_OFFSET_PX = 10; // how far the product can drift, in pixels
  var LERP_SPEED = 0.08; // easing factor for the trailing motion

  function prefersReducedMotion() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function hasFinePointer() {
    return window.matchMedia('(pointer: fine)').matches;
  }

  function initInstance(section) {
    var stage = section.querySelector('[data-mrh-stage]');
    if (!stage) return;

    var targetX = 0;
    var targetY = 0;
    var currentX = 0;
    var currentY = 0;
    var rafId = null;
    var bounds = null;

    function updateBounds() {
      bounds = section.getBoundingClientRect();
    }

    function onPointerMove(event) {
      if (!bounds) updateBounds();
      var relX = (event.clientX - bounds.left) / bounds.width; // 0..1
      var relY = (event.clientY - bounds.top) / bounds.height; // 0..1
      targetX = (relX - 0.5) * 2 * MAX_OFFSET_PX;
      targetY = (relY - 0.5) * 2 * MAX_OFFSET_PX;
      if (!rafId) rafId = requestAnimationFrame(tick);
    }

    function onPointerLeave() {
      targetX = 0;
      targetY = 0;
      if (!rafId) rafId = requestAnimationFrame(tick);
    }

    function tick() {
      currentX += (targetX - currentX) * LERP_SPEED;
      currentY += (targetY - currentY) * LERP_SPEED;

      stage.style.setProperty('--mrh-parallax-x', currentX.toFixed(2) + 'px');
      stage.style.setProperty('--mrh-parallax-y', currentY.toFixed(2) + 'px');

      var settled = Math.abs(targetX - currentX) < 0.05 && Math.abs(targetY - currentY) < 0.05;
      if (settled) {
        rafId = null;
        return;
      }
      rafId = requestAnimationFrame(tick);
    }

    updateBounds();
    section.addEventListener('mousemove', onPointerMove, { passive: true });
    section.addEventListener('mouseleave', onPointerLeave, { passive: true });
    window.addEventListener('resize', updateBounds, { passive: true });

    // Store cleanup on the element in case the theme editor reloads this section.
    section._maxrydeHeroCleanup = function () {
      section.removeEventListener('mousemove', onPointerMove);
      section.removeEventListener('mouseleave', onPointerLeave);
      window.removeEventListener('resize', updateBounds);
      if (rafId) cancelAnimationFrame(rafId);
    };
  }

  function initAll(root) {
    if (prefersReducedMotion() || !hasFinePointer()) return;
    var scope = root || document;
    var sections = scope.querySelectorAll('[data-maxryde-hero]');
    sections.forEach(function (section) {
      if (section._maxrydeHeroCleanup) section._maxrydeHeroCleanup();
      initInstance(section);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }

  // Re-init when a merchant edits/reloads this section in the Shopify Theme Editor.
  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
